<nav class="navbar navbar-expand-md navbar-light">
  <div class="total-logo">
    <img i18n-title="@@homeTip" src="./../../assets/TotalEnergies_logo.svg" class="logo"
         alt="TOTAL_Energies" title="Total Energies">
  </div>

  <div class="collapse navbar-collapse hide">
    <ul class="navbar-drpdwn" id="header-container" [class.justify-content-end]="isdataPlatform">
      <div class="nav-drpdown" [hidden]="isdataPlatform">
      <li class="nav-item">
        <div ngbDropdown class="refineryDrpdwn" *ngIf="refineryList!=undefined && refineryList.length>0">
          <div id="refinery" ngbDropdownToggle href="javascript:;">
            {{refineryName}}
          </div>
          <div ngbDropdownMenu aria-labelledby="refinery">
            <button class="dropdown-item" *ngFor="let refinery of refineryList" [id]="refinery"
                    (click)="populateTenant(refinery)">
              {{refinery}}
            </button>
          </div>
        </div>
      </li>
      <li class="nav-item m-0">
        <div ngbDropdown *ngIf="refineryList!=undefined && refineryList.length>0">
          <div id="tenant" ngbDropdownToggle href="javascript:;">
            {{tenantName}}
          </div>
          <div ngbDropdownMenu class="tenantDrpDwn" aria-labelledby="tenant">
            <button class="dropdown-item" *ngFor="let tenant of tenantList" [id]="tenant.tenantName"
                    (click)="onTenantChange(tenant)">
              {{tenant.tenantName}}
            </button>
          </div>
        </div>
      </li>
  </div>
  <div class="nav-drpdown">
    <li class="nav-item">
      <div class="btn-nav btn-home" (click)="goToHome()" matTooltip="Home"></div>
    </li>
    <li class="nav-item pr-3 mr-3">
      <div class="btn-nav btn-hub" (click)="globalService.redirectTo(globals.config.platformHubUrl)"
      (keydown)="globalService.redirectTo(globals.config.platformHubUrl)" matTooltip="Hub"></div>
    </li>
    <!--
    //NOSONAR
      <li class="nav-item borderRight pr-3 mr-3">
        <div class="btn-nav btn-help" (click)="globalService.redirectTo(globals.config.platformDocumentation)"
          matTooltip="Help"></div>
      </li> -->
    <li class="nav-item userDetails">
      <div [title]="globals.userName">
        {{ (globals.userName.length>20)? (globals.userName | slice:0:20)+'...':(globals.userName) }}
      </div>
      <div>
        {{globals.rbacName}}
      </div>
    </li>
    <li class="nav-item userAvatar">
      <div class="row">
        <div class="col-md-3">
          <div ngbDropdown class="pr-2 profile" display="dynamic">
            <div class="centered cursor-pointer" id="username" ngbDropdownToggle>
              {{
globals.userShortName | uppercase
              }}
            </div>
            <div ngbDropdownMenu aria-labelledby="profile">
              <div ngbDropdown class="cursor-pointer">
                <a class="dropdown-item cursor-pointer" (click)="openAboutRelease()">About Release</a>
              </div>
              <a class="dropdown-item" (click)="logout()">Sign out</a>
            </div>
          </div>
        </div>
      </div>
    </li>
  </div>
  </ul>
  </div>
</nav>
